import React, { Component }  from 'react';
import Heading from '../Components/heading';
import HeaderTextModule from './header_text_module'
import BodyCopyModule from './body_copy_module'
import SubTitleModule from './subtitle_module'
import QuoteModule from './quote_module'
import BulletListModule from './bullet_list_module'
import FixedMediaModule from './media_16_10'
import FlexibleMediaModule from './flexible_media'
export default (props) => { 
    let {sections} = props;
    return (
        sections.map((section, key) => {
            let selection = section['select_layout'];
            let data = section[selection];
            console.log(data)

            return (
                <React.Fragment>
                    {
                        selection == 'header_text_module' &&
                            <HeaderTextModule {...props} data={data} />
                    }
                    {
                        selection == 'body_copy_module' &&
                            <BodyCopyModule {...props} data={data} />
                    }
                    {
                        selection == 'subtitle_module' &&
                            <SubTitleModule {...props} data={data} />
                    }
                    {
                        selection == 'quote_module' &&
                            <QuoteModule {...props} data={data} />
                    }
                    {
                        selection == 'bullet_list_module' &&
                            <BulletListModule {...props} data={data} />
                    }
                    {
                        selection == 'bullet_list_module' &&
                            <HeaderTextModule {...props} data={data} />
                    }
                    {
                        selection == 'media_16_10' &&
                            <FixedMediaModule {...props} data={data} />
                    }
                    {
                        selection == 'flexible_media' &&
                            <FlexibleMediaModule {...props} data={data} />
                    }
                </React.Fragment>
            )
        })
    ) 
}



// WEBPACK FOOTER //
// ./src/components/Journals/Details/Layouts/Custom/index.js